import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import VehicleAddMain from '../../components/vehicle/VehicleAddMain'
import Footer from '../../components/common/Footer'

export default function VehicleAddPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <VehicleAddMain />
            <Footer/>
        </>
    )
}
